import React from 'react';
import { Link } from 'react-router-dom';
import { getConvertedPrice } from '../../utils/Utilities';

const OrderSummary = ({
    carts,
    currency,
    total,
    couponCode,
    setCouponCode,
    errorMessage,
    setErrorMessage,
    couponData,
    setCouponData,
    btnApplyCouponClick,
    formik,
    handleFormSubmit,
    xPay
}) => {
    // Add function to handle coupon removal
    const handleRemoveCoupon = () => {
        setCouponCode('');
        setCouponData(null);
    };

    return (
        <div className="checkout-summary">
            <div className="summary-header">
                <h3>Order Summary</h3>
            </div>

            {/* Coupon Section */}
            <div className="coupon-section">
                <div className="coupon-form">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter coupon code"
                        value={couponCode}
                        onChange={(e) => {
                            setCouponCode(e.target.value);
                            setErrorMessage(''); // Clear error when input changes
                        }}
                        disabled={!!xPay}
                    />
                    <button
                        className="btn btn-dark btn-apply"
                        onClick={btnApplyCouponClick}
                        disabled={!!xPay}
                    >
                        Apply
                    </button>
                </div>
                {errorMessage && (
                    <div className="error-message">
                        {errorMessage}
                    </div>
                )}
                {couponData && (
                    <div className="applied-coupon">
                        <span className="coupon-tag">
                            {couponData.coupon.code}
                            <button
                                onClick={handleRemoveCoupon}
                                title="Remove coupon"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </span>
                    </div>
                )}
            </div>

            {/* Cart Items */}
            <div className="summary-items">
                {carts && carts.length > 0 ? (
                    carts.map((item, index) => (
                        <div key={index} className="summary-item">
                            <div className="item-image">
                                <img src={item?.image} alt={item.name} />
                                <span className="item-quantity">{item.quantity}</span>
                            </div>
                            <div className="item-info">
                                <h4>{item.name}</h4>
                                {item.selected_variant?.item_variant_attributes?.map((attr, idx) => (
                                    <p key={`cart-item-${idx}`} className="mb-1 lh-1">
                                        <span className="text-dark">
                                            {attr.name}: {attr.item_attribute_value?.value}
                                        </span>
                                    </p>
                                ))}
                            </div>
                            <div className="item-price">
                                {currency?.currency?.symbol} {getConvertedPrice(item.selected_variant.sale_price)}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="empty-cart-message">
                        <p>Your cart is empty</p>
                        <Link to="/" className="btn btn-dark btn-sm">
                            Continue Shopping
                        </Link>
                    </div>
                )}
            </div>

            {/* Order Totals */}
            {carts && carts.length > 0 && (
                <>
                    <div className="summary-subtotal">
                        <div className="subtotal-row">
                            <span>Subtotal</span>
                            <span>{total?.currency} {total?.subTotal}</span>
                        </div>

                        {total?.gst > 0 && (
                            <div className="subtotal-row">
                                <span>GST ( {total?.gstPer} % )</span>
                                <span>{total?.currency} {total?.gst}</span>
                            </div>
                        )}

                        {total?.deliveryCharges > 0 && (
                            <div className="subtotal-row">
                                <span>Delivery Charges</span>
                                <span>{total?.currency} {total?.deliveryCharges}</span>
                            </div>
                        )}

                        {total?.incomeTaxEnabled && (
                            <div className="subtotal-row">
                                <span>Income Tax ( {total?.incomeTaxRate} % )</span>
                                <span>{total?.currency} {total?.incomeTax}</span>
                            </div>
                        )}

                        {total?.salesTaxEnabled && (
                            <div className="subtotal-row">
                                <span>Sales Tax ( {total?.salesTaxRate} % )</span>
                                <span>{total?.currency} {total?.salesTax}</span>
                            </div>
                        )}

                        {total?.coupon > 0 && (
                            <div className="subtotal-row discount">
                                <span>Discount</span>
                                <span>- {total?.currency} {total?.coupon}</span>
                            </div>
                        )}

                    </div>
                    <div className="summary-total">
                        <span>Total</span>
                        <span>{total?.currency} {total?.total}</span>
                    </div>
                    <button
                        className={`btn btn-dark btn-place-order ${formik.isSubmitting || !!xPay ? 'disabled' : ''}`}
                        onClick={handleFormSubmit}
                        disabled={formik.isSubmitting || !!xPay}
                    >
                        {formik.isSubmitting ? 'Processing...' : 'Place Order'}
                    </button>
                </>
            )}
        </div>
    );
};

export default OrderSummary; 